import { render, staticRenderFns } from "./concierge-table-content.html?vue&type=template&id=38cbb1ea&scoped=true&"
import script from "./concierge-table-content.js?vue&type=script&lang=js&"
export * from "./concierge-table-content.js?vue&type=script&lang=js&"
import style0 from "./concierge-table-content.scss?vue&type=style&index=0&id=38cbb1ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbb1ea",
  null
  
)

export default component.exports